export const API_URL = process.env.REACT_APP_API_URL || 'api';

export const WEB_URL = process.env.REACT_APP_WEB_URL || 'web';
